import { type BlobDeleteOptions, BlobServiceClient } from "@azure/storage-blob";
import { env } from "../config/env";

// Admin files
const containerName = env.STORAGE_CONTAINER;
const sasToken = env.STORAGESASTOKEN;
const storageAccountName = env.STORAGERESOURCENAME;
const blobService = new BlobServiceClient(`https://${storageAccountName}.blob.core.windows.net/?${sasToken}`);
const containerClient = blobService.getContainerClient(containerName);

export const STORAGE_URL = `https://${env.STORAGERESOURCENAME}.blob.core.windows.net/${env.STORAGE_CONTAINER}`;

// Heashots
const containerNameHs = env.HEADSHOTS_STORAGE_CONTAINER;
const sasTokenHs = env.HEADSHOTS_STORAGESASTOKEN;
const storageAccountNameHs = env.HEADSHOTS_STORAGERESOURCENAME;
const blobServiceHs = new BlobServiceClient(`https://${storageAccountNameHs}.blob.core.windows.net/?${sasTokenHs}`);
const containerClientHs = blobServiceHs.getContainerClient(containerNameHs);

// Content images
const containerNameCi = env.CONTENT_IMAGES_STORAGE_CONTAINER;
const sasTokenCi = env.CONTENT_IMAGES_STORAGESASTOKEN;
const storageAccountNameCi = env.CONTENT_IMAGES_STORAGERESOURCENAME;

const blobServiceCi = new BlobServiceClient(`https://${storageAccountNameCi}.blob.core.windows.net/?${sasTokenCi}`);
const containerClientCi = blobServiceCi.getContainerClient(containerNameCi);

export const isStorageConfigured = () => {
	return !storageAccountName || !sasToken ? false : true;
};

export const getBlobInContainer = async (name: string) => {
	const returnedBlobUrls = [];

	// get list of blobs in container
	// eslint-disable-next-line
	await returnedBlobUrls.push({
		blobName: name,
		blobUrl: `https://${storageAccountName}.blob.core.windows.net/${containerName}/${name}`,
	});

	return returnedBlobUrls;
};
export const getBlobsInContainer = async () => {
	const returnedBlobUrls = [];

	// get list of blobs in container
	// eslint-disable-next-line
	for await (const blob of containerClient.listBlobsFlat()) {
		// if image is public, just construct URL
		returnedBlobUrls.push({
			blobName: blob.name,
			blobUrl: `https://${storageAccountName}.blob.core.windows.net/${containerName}/${blob.name}`,
		});
	}

	return returnedBlobUrls;
};

export const createBlobInContainer = async (file: File, filename: string | null = null) => {
	const fileName = filename === null ? file.name : filename;
	console.log("createBlobInContainer file", file);
	// create blobClient for container
	const blobClient = containerClient.getBlockBlobClient(fileName);

	// set mimetype as determined from browser with file upload control
	const options = { blobHTTPHeaders: { blobContentType: file.type } };

	// upload file
	await blobClient.uploadData(file, options);
};

export const deleteBlobIfItExists = async (blobName: string) => {
	// include: Delete the base blob and all of its snapshots.
	// only: Delete only the blob's snapshots and not the blob itself.
	const options = {
		deleteSnapshots: "include", // or 'only'
	};

	// Create blob client from container client
	const blockBlobClient = await containerClient.getBlockBlobClient(blobName);

	await blockBlobClient.deleteIfExists(options as BlobDeleteOptions);

	console.log(`deleted blob ${blobName}`);
};

export const createHeadshotInContainer = async (file: File, filename: string) => {
	console.log("createHeadshotInContainer file", file, filename);
	// create blobClient for container
	const blobClientHs = containerClientHs.getBlockBlobClient(filename);

	// set mimetype as determined from browser with file upload control
	const options = { blobHTTPHeaders: { blobContentType: file.type } };

	// upload file
	await blobClientHs.uploadData(file, options);
};

export const createContentImageInContainer = async (file: File, filename: string) => {
	console.log("createContentImageInContainer file", file, filename);
	// create blobClient for container
	const blobClientHs = containerClientCi.getBlockBlobClient(filename);

	// set mimetype as determined from browser with file upload control
	const options = { blobHTTPHeaders: { blobContentType: file.type } };

	// upload file
	await blobClientHs.uploadData(file, options);
};
